import { useState } from "react";
import { PageHeader } from "@/components/PageHeader";
import { AddButton, SearchInput, ListCard, Empty } from "@/components/Bits";
import { EquipamentoFormDialog } from "@/components/EquipamentoFormDialog";
import { TIPOS, tipoIcon, EQ_STATUS } from "@/config/equipamentos";
import { useAuth } from "@/context/AuthContext";
import { useFetch } from "@/lib/useFetch";

const Chip = ({ active, children, ...p }) => (
  <button {...p} className={`h-11 px-4 rounded-full border-2 text-sm font-semibold whitespace-nowrap transition-colors ${active ? "bg-[#1E4D2B] border-[#1E4D2B] text-white" : "bg-white border-[#E2DDD3] hover:border-[#1E4D2B]"}`}>{children}</button>
);

export const ChipRow = ({ children }) => <div className="flex gap-2 overflow-x-auto pb-2 mb-4 -mx-4 px-4 sm:mx-0 sm:px-0">{children}</div>;
export { Chip };

export default function EquipamentosPage() {
  const { user } = useAuth();
  const [q, setQ] = useState("");
  const [tipo, setTipo] = useState("");
  const [open, setOpen] = useState(false);
  const { data, reload } = useFetch("/equipamentos", { q: q || undefined, tipo: tipo || undefined });

  return (
    <div data-testid="equipamentos-page">
      <PageHeader eyebrow="Frota" title="Equipamentos" subtitle="Máquinas e tecnologias embarcadas, com histórico individual." />
      <div className="flex gap-3 mb-4">
        <SearchInput value={q} onChange={setQ} placeholder="Buscar marca, modelo, série, código" testId="equip-search-input" />
        {user.role !== "tecnico" && <AddButton onClick={() => setOpen(true)} data-testid="equip-add-button">Novo</AddButton>}
      </div>
      <ChipRow>
        <Chip active={!tipo} onClick={() => setTipo("")} data-testid="equip-filter-all">Todos</Chip>
        {Object.entries(TIPOS).map(([k, t]) => <Chip key={k} active={tipo === k} onClick={() => setTipo(k)} data-testid={`equip-filter-${k}`}>{t.label}</Chip>)}
      </ChipRow>
      {data?.length === 0 && <Empty testId="equip-list-empty">Nenhum equipamento encontrado.</Empty>}
      <div className="grid md:grid-cols-2 gap-3" data-testid="equip-list">
        {(data || []).map((e) => (
          <ListCard key={e.equipamento_id} to={`/equipamentos/${e.equipamento_id}`} icon={tipoIcon(e.tipo)} testId={`equip-card-${e.equipamento_id}`}
            title={e.titulo} subtitle={`${e.fazenda_nome || ""} · ${e.cliente_nome || ""}`}
            meta={`${e.codigo} · ${EQ_STATUS[e.status]}`} />
        ))}
      </div>
      <EquipamentoFormDialog open={open} onOpenChange={setOpen} onSaved={reload} />
    </div>
  );
}
